import { render, staticRenderFns } from "./delivery-prices.vue?vue&type=template&id=b9b2ced6&"
import script from "./delivery-prices.vue?vue&type=script&lang=js&"
export * from "./delivery-prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports